import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "lockedFilled"
const LockedFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M12 1.5C13.392 1.5 14.728 2.053 15.713 3.037 16.697 4.022 17.25 5.357 17.25 6.75V9.504Q17.553 9.578 17.809 9.654 17.904 9.683 17.993 9.709 18.063 9.732 18.13 9.755 18.463 9.865 18.705 9.97L18.808 10.017Q18.888 10.052 18.958 10.087L18.97 10.09 19.041 10.13C19.367 10.3 19.496 10.418 19.5 10.421V21Q19.5 21.078 19.492 21.153 19.484 21.223 19.47 21.293L19.457 21.348Q19.448 21.388 19.437 21.425L19.418 21.487Q19.405 21.524 19.39 21.56L19.368 21.612Q19.351 21.65 19.332 21.686L19.306 21.736 19.263 21.806 19.233 21.853 19.19 21.91Q19.07 22.069 18.91 22.19 18.882 22.212 18.853 22.233L18.806 22.263Q18.772 22.285 18.736 22.306 18.712 22.32 18.686 22.332 18.65 22.352 18.612 22.368L18.56 22.39Q18.524 22.405 18.487 22.417L18.425 22.437Q18.388 22.449 18.349 22.458L18.292 22.47Q18.223 22.485 18.153 22.49 18.078 22.5 18 22.5H6C5.172 22.5 4.5 21.828 4.5 21V10.42Q4.501 10.419 4.576 10.36C4.646 10.308 4.77 10.227 4.96 10.13Q4.994 10.11 5.034 10.09 5.107 10.052 5.19 10.016L5.295 9.969Q5.536 9.865 5.869 9.755 5.936 9.731 6.007 9.708L6.19 9.655Q6.446 9.578 6.75 9.504V6.75C6.75 5.358 7.303 4.022 8.287 3.037 9.272 2.053 10.607 1.5 12 1.5M12 14.25C11.172 14.25 10.5 14.922 10.5 15.75S11.172 17.25 12 17.25 13.5 16.578 13.5 15.75 12.828 14.25 12 14.25M12 3C11.005 3 10.052 3.395 9.349 4.099 8.645 4.802 8.25 5.755 8.25 6.75V9.229Q8.457 9.199 8.677 9.174 8.753 9.166 8.833 9.157 9.157 9.122 9.512 9.092L9.554 9.09C10.27 9.033 11.083 9 12 9S13.728 9.033 14.446 9.09L14.487 9.091Q14.842 9.122 15.167 9.157 15.244 9.165 15.321 9.174 15.543 9.2 15.75 9.229V6.75C15.75 5.755 15.355 4.802 14.651 4.099 13.948 3.395 12.995 3 12 3"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default LockedFilledIcon
